import { Grid, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import { Footer } from '../../components/footer';
import { injectTSDI } from '../../core/common/tsdi';
import { I18n } from '../../core/i18n';
import { SharedContractDissolutionStore } from '../shared-contract-dissolution-store';
import { BottomPaddedGridItemM, BottomPaddedGridItemS } from '../styles';
import { ContractTerminationPage } from './contract-termination-page';
import { ContractTerminationStore } from './contract-termination-store';
import { ManualTerminationSuccessPageContainer } from './termination-success/manual-termination-succes-page-container';
import { TerminationSuccessPageContainer } from './termination-success/termination-success-page-container';

const CenterGrid = styled(Grid)`
    text-align: justify;
    padding: 0 10px 0 10px;
    margin-top: 50px;
`;

const StyledBottomPaddedGridItemM = styled(BottomPaddedGridItemM)`
    width: inherit;
`;

export interface ContractTerminationProps {
    tenant?: string | null;
}

export const ContractTermination = observer(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    (_props: ContractTerminationProps) => {
        const { translate } = injectTSDI(I18n);
        const {
            cancelContractRequest,
            cancelContractManualRequest,
            cancelContractManualForm
        } = injectTSDI(ContractTerminationStore);

        const { getStudioInfo, getStudio } = injectTSDI(
            SharedContractDissolutionStore
        );

        const selectedStudioName = getStudio(
            cancelContractManualForm.wrappedField.studioId.value
        )?.studioPublicDto?.name;

        return (
            <>
                <CenterGrid
                    container
                    direction="column"
                    alignContent="space-around"
                    data-scan-target
                >
                    <StyledBottomPaddedGridItemM
                        item
                        xs={12}
                        sm={10}
                        md={8}
                        lg={7}
                        xl={5}
                    >
                        <Typography variant="h4" component="h1">
                            {translate('public.content.terminate.contract')}
                        </Typography>
                    </StyledBottomPaddedGridItemM>
                    <BottomPaddedGridItemS
                        item
                        xs={12}
                        sm={10}
                        md={8}
                        lg={7}
                        xl={5}
                    >
                        {cancelContractRequest.state !== 'fetched' &&
                        cancelContractManualRequest.state !== 'fetched' ? (
                            <ContractTerminationPage data-scan-target />
                        ) : (
                            ''
                        )}
                    </BottomPaddedGridItemS>
                    {cancelContractRequest.state &&
                        !cancelContractManualRequest.state && (
                            <BottomPaddedGridItemM
                                item
                                xs={12}
                                sm={10}
                                md={8}
                                lg={7}
                                xl={5}
                            >
                                <TerminationSuccessPageContainer
                                    showOnlySuccess
                                />
                            </BottomPaddedGridItemM>
                        )}
                    {!cancelContractRequest.state &&
                        cancelContractManualRequest.state && (
                            <BottomPaddedGridItemM
                                item
                                xs={12}
                                sm={10}
                                md={8}
                                lg={7}
                                xl={5}
                            >
                                <ManualTerminationSuccessPageContainer />
                            </BottomPaddedGridItemM>
                        )}
                </CenterGrid>
                <Footer
                    legalLinks={getStudioInfo.result?.legalLinks ?? []}
                    studioName={selectedStudioName}
                />
            </>
        );
    }
);
